// extracted by mini-css-extract-plugin
export default {"bankIDPersonalNumber":"styles_bankIDPersonalNumber__RgWB9","logo":"styles_logo__2pCzq","button":"styles_button__lUzr6"};